import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ShoppingBag, ShieldCheck } from 'lucide-react';
export function PricingSection() {
  return <Section id="pricing" background="cream" data-id="element-118">
      <div className="max-w-md mx-auto" data-id="element-119">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100" data-id="element-120">
          <div className="bg-[#1e3a5f] p-4 text-center" data-id="element-121">
            <h2 className="text-xl font-bold text-white mb-1" data-id="element-122">
              Oferta Especial
            </h2>
            <p className="text-blue-200 text-sm" data-id="element-123">
              Recupera la calma en tu hogar
            </p>
          </div>

          <div className="p-6 text-center" data-id="element-124">
            <h3 className="text-2xl font-bold text-[#1e3a5f] mb-1" data-id="element-125">
              Pantallas Bajo Control
            </h3>
            <p className="text-gray-500 mb-4 uppercase tracking-wider text-xs font-semibold" data-id="element-126">
              Programa de 30 Días
            </p>

            <div className="flex items-center justify-center mb-5" data-id="element-127">
              <span className="text-4xl font-extrabold text-[#dc4a3d]" data-id="element-128">
                $6.39
              </span>
              <span className="text-gray-400 ml-2 text-lg" data-id="element-129">USD</span>
            </div>

            <Button fullWidth size="md" className="mb-4 shadow-lg shadow-red-200" href="https://tucambiohoy.online/cart/42988674941041:1" data-id="element-130">
              <ShoppingBag className="w-4 h-4 mr-2" data-id="element-131" />
              Descargar Ahora
            </Button>

            <p className="text-xs text-gray-400 mb-5" data-id="element-132">
              Entrega digital inmediata vía email. Pago seguro.
            </p>

            <div className="bg-gray-50 p-3 rounded-lg flex items-start text-left" data-id="element-133">
              <ShieldCheck className="w-8 h-8 text-[#1e3a5f] mr-2 flex-shrink-0" data-id="element-134" />
              <div data-id="element-135">
                <p className="font-bold text-[#1e3a5f] text-xs mb-0.5" data-id="element-136">
                  Garantía de 7 días
                </p>
                <p className="text-xs text-gray-600 leading-relaxed" data-id="element-137">
                  Si en 7 días no te sientes más claro(a) y con más control, te
                  devuelvo tu dinero. Sin preguntas.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}